import { FC, ReactNode } from 'react';

import styled, { css } from '@mint-lib/styled';

import { Truncation } from '@myn/mui';

import { TextFieldProps } from '../types.js';

type Props = Pick<TextFieldProps, 'scale' | 'color'> & {
  children: ReactNode;
};

const TextVariant: FC<Props> = ({ scale, color, children }) => {
  if (!children) {
    return null;
  }

  return (
    <StyledTruncation $scale={scale} color={color}>
      {children}
    </StyledTruncation>
  );
};

export default TextVariant;

const StyledTruncation = styled(Truncation)<{
  $scale: number;
}>`
  ${({ $scale }) => css`
    width: auto;
    text-align: right;
    text-transform: none;
    font-size: ${0.875 * $scale}rem;
    line-height: ${$scale}rem;
  `}
`;
